export const Event = {
  AuthLogout: "auth-logout",
  AuthSignedIn: "auth-signed-in",
  AuthAdminSignedIn: "auth-admin-signed-in",
  AuthChangedPassword: "auth-changed-password",
  AuthAcceptedInvitation: "auth-accepted-invitation",
  AuthRequestResetPassword: "auth-request-password-reset",
  AuthRequestVerificationEmail: "auth-request-verification-email",
  AuthRegisteredAccount: "auth-registered-account",
  AuthNavigateToSignIn: "auth-navigate-to-sign-in",
  AuthNavigateToRegister: "auth-navigate-to-register",
  AuthNavigateToResetPassword: "auth-navigate-to-reset-password",
  AuthSelectedAccount: "auth-selected-account",
  AuthLoginWithApple: "auth-login-with-apple",
  AuthLoginWithGithub: "auth-login-with-github",
  AuthLoginWithGoogle: "auth-login-with-google",
  AuthLoginWithFacebook: "auth-login-with-facebook",

  MapNavigateToOverview: "map-navigate-to-overview",

  MapSearchMaps: "map-search-map",
  MapCreateNewMap: "map-create-new-map",
  MapDeleteMap: "map-delete-map",

  ChangedAccountBillingEmail: "changed-account-billing-email",

  TilesetSearchTilesets: "tileset-search-tilesets",
  TilesetNavigateToOverview: "tileset-navigate-to-overview",
  TilesetDatasetNavigateToOverview: "tileset-dataset-navigate-to-overview",
  TilesetAddSource: "tileset-add-source",
  TilesetRemoveSource: "tileset-remove-source",
  TilesetAddLayer: "tileset-add-layer",
  TilesetRemoveLayer: "tileset-remove-layer",
  TilesetCreateNewTileset: "tileset-create-new-tileset",
  TilesetDeleteTileset: "tileset-delete-tileset",
  TilesetDeleteVersion: "tileset-delete-version",

  OverviewStartChat: "overview-start-chat",
  CancelPaymentRequiredModal: "cancel-payment-required-modal",
  NavigateFromPaymentRequiredModal: "navigate-from-payment-required-modal",
  NavigateFromPaymentRequiredAlert: "navigate-from-payment-required-alert",

  MapCreateNewMapSuccess: "map-create-new-map-success",
  TilesetCreateNewTilesetSuccess: "tileset-create-new-tileset-success",
  ShareMapModalOpened: "share-map-modal-opened",
  ShareMapTabChanged: "share-map-tab-changed",
  ShareMapUrlCopied: "share-map-url-copied",

  LearnByWatchingVideoStarted: "learn-by-watching-video-started",
};

export type Event = typeof Event[keyof typeof Event];

export const FEEDBACK_CONTROL_ID = "posthog-feedback-control";
